<template>
  <div
    class="flexCC search-tag-container"
    :class="{ 'no-scroll': !scorllFlag }"
    @click.stop
  >
    <el-button
      type="secondary"
      class="search-tag-btn"
      icon="el-icon-d-arrow-left"
      :disabled="tagLeftDisable_"
      @click="handleMoveTag('left')"
    />
    <div class="search-form-tag">
      <div
        ref="scrollView"
        v-resize="resizeTagWidth"
        class="search-form-scroll"
        @scroll="onTagScroll"
      >
        <el-tag
          v-for="(item, index) in list"
          :key="index"
          size="mini"
          :closable="!item.disabled && !item.required"
          @close="handleClose(item,index)"
        >
          <div class="tag-value">{{ item[option_.label] }}</div>
        </el-tag>
      </div>
    </div>
    <el-button
      type="secondary"
      class="search-tag-btn"
      icon="el-icon-d-arrow-right"
      :disabled="tagRightDisable_"
      @click="handleMoveTag('right')"
    />
  </div>
</template>

<script>
import '../../../../lib/styles/components/SearchTagGroup.scss'
export default {
  name: 'SearchTagGroup',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      defaultOption: {
        label: 'label' // label值的key
      },
      scrollWidth: 0, // 记录index触发计算属性重新计算
      scorllFlag: false, // 是否出现滚动按钮
      tagTimer: null, // tag防抖定时器
      tagScrollLeft: 0 // 当前滚动条位置
    }
  },
  computed: {
    // 左侧按钮是否可点
    tagLeftDisable_() {
      return this.tagScrollLeft < 1
    },
    // 右侧按钮是否可点
    tagRightDisable_() {
      const tagScrollLeft = this.tagScrollLeft
      const el = this.$refs.scrollView
      if (!el) return false
      const scrollWidth = this.scrollWidth - el.clientWidth // 可滚动的最大距离
      return scrollWidth - tagScrollLeft < 1
    },
    option_() {
      return Object.assign({}, this.defaultOption, this.option)
    }
  },
  watch: {
    // 监听tag变化判断是否出现滚动条
    list() {
      setTimeout(() => {
        this.resizeTagWidth()
      }, 500)
    }
  },
  methods: {
    handleClick(item, index) {
      this.$emit('click', item, index)
    },
    resizeTagWidth() {
      const el = this.$refs.scrollView
      if (!el) return
      const clientWidth = el.clientWidth
      const scrollWidth = el.scrollWidth
      this.tagScrollLeft = el.scrollLeft
      this.scrollWidth = scrollWidth
      this.scorllFlag = scrollWidth > clientWidth
    },
    // 监听滚动
    onTagScroll(e) {
      if (this.tagTimer) {
        clearTimeout(this.tagTimer)
      }
      this.tagTimer = setTimeout(() => {
        const el = this.$refs.scrollView
        this.tagScrollLeft = el.scrollLeft
      }, 50)
    },
    // 左右滚动
    handleMoveTag(type) {
      const el = this.$refs.scrollView
      let move = el.clientWidth * 0.4
      if (type === 'left') {
        move = -move
      }
      this.scrollTo({ el, move })
    },
    // 基于当前位置滚动一段距离
    scrollTo({ el = null, move = 0, duration = 500 } = {}) {
      if (!el) return
      let strTime = 0
      const scrollLeft = el.scrollLeft // 起始位置
      const offsetLeft = scrollLeft + move // 要移动到的位置
      const scrollFrame = (timer) => {
        if (strTime === 0) {
          strTime = timer
        }
        const elapsed = timer - strTime
        const params = { scrollLeft, offsetLeft, elapsed, duration }
        const offset = this.getOffset(params)
        if (elapsed <= 500) {
          window.requestAnimationFrame(scrollFrame)
          el.scrollTo(offset, 0)
        }
      }
      window.requestAnimationFrame(scrollFrame)
    },
    getOffset(data) {
      const { scrollLeft, offsetLeft, elapsed, duration } = data
      let offset
      // 判断左右滚动
      if (scrollLeft > offsetLeft) {
        offset = scrollLeft - (elapsed / duration) * (scrollLeft - offsetLeft)
      } else {
        offset = scrollLeft + (elapsed / duration) * (offsetLeft - scrollLeft)
      }
      return offset
    },
    handleClose(value, index) {
      this.$emit('onClose', { value, index })
    }
  }
}
</script>
